import React, { Component } from 'react';
import { backgroundArtworks } from '../configs/backgroundArtworks.config';

var artwork =
  backgroundArtworks[Math.floor(Math.random() * backgroundArtworks.length)];
class SignUpChooser extends Component {
  // componentDidMount() {
  //   const { history } = this.props;
  //   setTimeout(() => history.push('/'), 500);
  // }

  goToConnectLoginPage = () => {
    const { history } = this.props;
    return history.push('/sign-up-to?returnTo=connect');
  };

  goToClientLoginPage = () => {
    const { history } = this.props;
    return history.push('/sign-up-to?returnTo=collect');
  };

  render() {
    return (
      <div
        className='home-page-wrapper'
        style={{ backgroundImage: `url(${artwork.asset})` }}
      >
        <div className='artwork-details'>
          <span className='artist-name'>{artwork.artistName}</span>
          <br />
          <span className='artwork-title'>
            {artwork.title}, {artwork.year}
          </span>
        </div>
        <span className='all-rights-reserved'>
          &copy; {new Date().getFullYear()} Arteïa - All rights reserved
        </span>
        <div className='content-wrapper'>
          <img src='/assets/logo-text.png' />
          <h1>You can choose between apps</h1>
          <div className='content-container'>
            <div className='text-with-icon'>
              <div className='text-container'>
                <img src='/ico-see-demo.svg' />
                <div>
                  <h2>
                    ARTEÏA COLLECT
                  </h2>
                </div>
              </div>
              <span className='above-button'>
                Inventory / Collection Management System
              </span>
              <button
                  className='collection-button-desktop'
                  onClick={() => this.goToClientLoginPage()}
                >
                  Sign up to ARTEÏA COLLECT
                </button>
              <span className='below-button'>
                Inventaire / Système de gestion de collection
              </span>
            </div>

            <div id='text-with-icon' className='text-with-icon'>
              <div className='text-container'>
                <img src='/ico-arteia-connect.svg' className='connect-img' />
                <div>
                  <h2>ARTEÏA CONNECT</h2>
                </div>
              </div>
              <span className='above-button'>NFC Authentication</span>
              <button
                className='connect-button-desktop'
                onClick={() => this.goToConnectLoginPage()}
              >
                Sign up to ARTEÏA CONNECT
              </button>
              <span className='below-button'>
                Authentification par puces NFC
              </span>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

SignUpChooser.propTypes = {};
SignUpChooser.defaultProps = {};

export default SignUpChooser;



// WEBPACK FOOTER //
// ./src/scenes/SignUpChooser/SignUpChooser.js